import { render, staticRenderFns } from "./OverstayRegulationSpecialForm.vue?vue&type=template&id=960d729c&"
import script from "./OverstayRegulationSpecialForm.vue?vue&type=script&lang=js&"
export * from "./OverstayRegulationSpecialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports